import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "frontend-implementation"
    }}>{`Frontend Implementation`}</h1>
    <p>{`Headless Frontend Section `}{`[user view]`}{` basically build based on this procedure.`}</p>
    <ol>
      <li parentName="ol">{`Pages are built according to NextJS paradigm.`}</li>
      <li parentName="ol">{`Each pages are build on some Containers`}</li>
      <li parentName="ol">{`Each Container hold on some components`}</li>
      <li parentName="ol">{`Components render the data and perform their tasks 5. Datas are fetched via the GraphQL queries.`}</li>
    </ol>
    <p>{`Now, Pages, Containers & Components related information you can grab via the project folder structure discussed before. Let's make a dive into the Data fetching using GraphQL queries and some very related tasks.`}</p>
    <p>{`For data fetching we are using `}<strong parentName="p">{`useQuery`}</strong>{` hook from `}<inlineCode parentName="p">{`@apollo/react-hooks`}</inlineCode></p>
    <p><strong parentName="p">{`For example :`}</strong></p>
    <p>{`let's discuss here a query to fetch post data and display on the Home grid.`}</p>
    <p><strong parentName="p">{`GraphQL Query :`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import gql from 'graphql-tag';
export const GET_ALL_POST = gql\`
  query getAllPost($LIMIT: Int, $page: Int) {
    posts(limit: $LIMIT, page: $page) {
      data {
        id
        slug
        title
        price
        image {
            url
            largeUrl
        }
    }
        total
    }
}\`;
`}</code></pre>
    <p>{`Then this query need to be called in the Container where you need to display & process the data.`}</p>
    <p>{`Now, in the Home container import that query and prepared the data.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// pseudo code //
import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { GET_ALL_POST } from '[FROM-THE-JS-FILE-THE-QUERY-IS-WRITTEN]';
const Home = () => {
  // QUERY SECTION
  let QUERY_VARIABLES = {
    LIMIT: 8,
  };
  const { data, loading, error } = useQuery(GET_ALL_POST, {
    variables: QUERY_VARIABLES,
  });
  // Extract Post Data
  const postData = data.posts ? data.posts.data : [];
  return (
    <React.Fragment>
      <YOUR_HOME_CONTAINER />
    </React.Fragment>
); }
export default Home
`}</code></pre>
    <h2 {...{
      "id": "auth"
    }}>{`Auth`}</h2>
    <p>{`This Application uses Cookie to store the token, As a complete server side rendering app you need to use cookie. as cookie can be accessible from both server and the client. Now, I will discuss how Authentication works in this application and it's flow.`}</p>
    <p><strong parentName="p">{`Basic Login Step:`}</strong></p>
    <ol>
      <li parentName="ol">{`First, Go to the Signin or Signup page`}</li>
      <li parentName="ol">{`provide your email, password or mobile number`}</li>
      <li parentName="ol">{`click on the signin or signup button`}</li>
      <li parentName="ol">{`if your credentials are ok,then firebase will return a token 5. then we have saved this token in to the cookie`}</li>
      <li parentName="ol">{`and redirect to the homepage as a logged in user`}</li>
    </ol>
    <p>{`so, we have seen in the above step that how we are getting the token from the firebase and using it as our initial login. to check the code first you need to go to the below file,`}</p>
    <p><inlineCode parentName="p">{`packages/web/containers/SignInForm`}</inlineCode>{` or `}<inlineCode parentName="p">{`packages/web/containers/SignUpForm`}</inlineCode></p>
    <p><img alt="SignupForm.png" src={require("./images/SignupForm.png")} /></p>
    <p>{`in the above file we have used Formik to handle form data and then used our AuthHelper to send this data to firebase. Look at the `}<strong parentName="p">{`handleSubmit`}</strong>{` function, after doing the request firebase will return the `}<strong parentName="p">{`user`}</strong>{` which have use to get the token. Then we have set the token using `}<strong parentName="p">{`setFieldValue`}</strong>{` which will revoke the useEffect hook and set our token using the `}<strong parentName="p">{`setFirebaseCookie`}</strong>{` function.`}</p>
    <p><img alt="Signup2.png" src={require("./images/Signup2.png")} /></p>
    <p>{`so, now you have your token in your cookie and you are in the home page as a logged in user. but wait, theres more to it. what we have just done is just frontend authentication. but we need to check our protected page (profile, add post) and validate the user if they are the right user to access the page, also when adding new post or doing any changes in the account page we need to validate the user in the backend as well.`}</p>
    <p>{`So, Now I will discuss this two section, How we have handled our protected page and how we have validate a user in the backend/admin section.`}</p>
    <h3 {...{
      "id": "protectedrestrictedsecret-page"
    }}>{`Protected/Restricted/Secret Page:`}</h3>
    <p>{`If a visitor comes to your site and not logged in yet, you will not want them to access any Profile, Account Settings, Add Post page as this page should only be available to your site users or members. The page is available in the menu (except the profile/account settings page) but when a visitor try to go to this page they will be redirected to the login page. We have create a HOC you will find it in the `}<inlineCode parentName="p">{`packages/web/hoc/secretPage.js`}</inlineCode>{` here we have checked if the token available in our cookie using the context of `}<inlineCode parentName="p">{`getInitializeProps`}</inlineCode>{`. if true then the user is logged in other wise the user can't access the protected page.`}</p>
    <p><img alt="Protected.png" src={require("./images/Protected.png")} /></p>
    <p>{`This hoc secretPage is applied to the `}<inlineCode parentName="p">{`packages/web/pages/add-post.js`}</inlineCode></p>
    <p><img alt="AddPost.png" src={require("./images/AddPost.png")} /></p>
    <h3 {...{
      "id": "backendadmin-validation-check"
    }}>{`Backend/Admin Validation Check:`}</h3>
    <p>{`Once we have set our token into the Cookie, the server will always get access to this token using our apollo configuration.`}</p>
    <p>{`we have followed the below docs from Apollo,`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.apollographql.com/docs/apollo-server/features/authentication"
      }}>{`https://www.apollographql.com/docs/apollo-server/features/authentication`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://www.apollographql.com/docs/react/recipes/authentication"
      }}>{`https://www.apollographql.com/docs/react/recipes/authentication`}</a></p>
    <p>{`and here's how we have done it in the code,`}</p>
    <p>{`first go to the `}<inlineCode parentName="p">{`packages/web/helpersdirectory`}</inlineCode>{` look at the `}<inlineCode parentName="p">{`apollo.js`}</inlineCode>{` file.`}</p>
    <p>{`we have send the token to the apollo graphql server, now we need to validate this token in the backend, here how we have done it,`}</p>
    <ol>
      <li parentName="ol">{`first we have retrieve the token in the `}<inlineCode parentName="li">{`packages/server/server.js`}</inlineCode>{` file(fordeploymentwe have used the index.js)`}</li>
    </ol>
    <p><img alt="Retrieve.png" src={require("./images/Retrieve.png")} /></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`thegetUserfunctionvalidatethistokenusingfirebaseadmintokenverifyIdToken function. To identify a user is owner, same user, admin of a post we have used Graphql Schield (`}<a parentName="li" {...{
          "href": "https://github.com/maticzav/graphql-shield"
        }}>{`https://github.com/maticzav/graphql-shield`}</a>{`) as middleware.`}</li>
    </ol>
    <p>{`That's it, This is the whole Authentication flow of this application.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      